module.exports = __webpack_public_path__ + "static/media/gap-insurance_color.5ef92ae4.png";